<template>
    <LoaderSplash :loaded="loaded">
        <b-container v-if="loaded">
            <b-row>
                <b-col>
                    <h1>
                        Edit {{ client.name }}
                    </h1>

                    <b-form @submit.prevent="onSubmit">
                        <b-form-group>
                            <label>
                                Name
                            </label>

                            <b-form-input
                                type="text"
                                v-model="form.name"
                                required
                                placeholder="Name">    
                            </b-form-input>

                            <label>
                                User
                            </label>

                            <b-form-select
                                    v-model="form.user_id"
                                    :options="user_options"
                                    class="mb-2">

                                <template slot="first">
                                    <option :value="null" disabled>None</option>
                                </template>

                            </b-form-select>
                        </b-form-group>

                        <hr>

                        <b-form-group class="mt-0">
                            <b-row>
                                <b-col md-6>
                                    <label>
                                        Logo
                                    </label>

<!--                                    <image-picker-->
<!--                                        :current_image_url="form.logo"-->
<!--                                        :bg_color="form.header_color"-->
<!--                                        @image-picked="(base64) => { form.logo_base64 = base64; }">-->
<!--                                    </image-picker>-->
                                    <simple-image-picker
                                            :src="form.logo"
                                            :width="200"
                                            :bg_color="form.header_color"
                                            @image-picked="(base64) => { form.logo_base64 = base64; }">
                                    </simple-image-picker>
                                </b-col>

                                <b-col md-6>
                                    <label>
                                        Colour Scheme
                                    </label>

                                    <colour-picker class="mt-3" 
                                        :colour="form.header_color"
                                        name="Header bar colour"
                                        @colour-picked="(new_color) => { form.header_color = new_color; }">
                                    </colour-picker>

                                    <colour-picker class="mt-3" 
                                        :colour="form.footer_color"
                                        name="Footer bar colour"
                                        @colour-picked="(new_color) => { form.footer_color = new_color; }">
                                    </colour-picker>

                                    <div class="custom-fields mt-5">
                                        <label>Custom Invite Fields</label>

                                        <editable-custom-field-list
                                            :fields="client.custom_invite_fields"
                                            @changed="fields => { form.custom_invite_fields = fields; }">
                                        </editable-custom-field-list>
                                    </div>
                                </b-col>
                            </b-row>
                        </b-form-group>

                        <b-button type="submit" variant="primary">
                            Submit
                        </b-button>
                    </b-form>
                </b-col>
            </b-row>
        </b-container>
    </LoaderSplash>
</template>

<script>
    //import ImagePicker from '@/components/ImagePicker.vue';
    import SimpleImagePicker from '@/components/SimpleImagePicker.vue';
    import ColourPicker from '@/components/ColourPicker.vue';
    import clientRespository from "@/repository/clients";
    import userRepository from "@/repository/users";
    import EditableCustomFieldList from "@/components/EditableCustomFieldList.vue";

    export default {
        components: {
            //ImagePicker,
            SimpleImagePicker,
            ColourPicker,
            EditableCustomFieldList
        },

        props: ['id'],

        data() {
            return {
                image_dimensions: {
                    height: 100,
                    width: 200
                },
                client: null,
                loaded: false,
                errors: {},
                users:[],
                form: {}
            }
        },

        mounted(){
            clientRespository.getById(
                this.id,
                {
                    include: 'user'
                })
                .then(response => {
                    //response.data.email = response.data.user.email;
                    this.client = response.data;
                    this.form = { ...this.client };
                    //this.loaded = true;
                    userRepository.getAll()
                        .then(response => {
                            this.users= response.data;
                            this.loaded = true;
                        });
                });

            
        },

        computed: {
            user_options(){
                return this.users.map((user)=>{
                    return {
                        value: user.id,
                        text: user.name
                    }
                })
            }
        },

        methods: {
            onSubmit() {
                clientRespository.update(this.form)
                    .then(response => {
                        this.$notify({
                            group: 'main',
                            type: 'success',
                            title: 'Client Edited',
                            text: 'New client successfully edited.'
                        });
                    }).catch(error => {
                        if (error.response.status == 422) {
                            let e = error.response.data.errors;

                            let errors = Object.keys(e).map(key => {
                                return e[key].join("<br/>");
                            }).join("<br/>");

                            this.$notify({
                                group: 'main',
                                type: 'error',
                                title: 'Form Errors',
                                text: errors,
                                duration: 10000,
                                width: '500px'
                            });
                        }
                    });

                
            }
        }
    }
</script>

<style scoped lang="scss">

</style>